import { render, staticRenderFns } from "./FeatherIconWrapper.vue?vue&type=template&id=11f34aae&"
import script from "./FeatherIconWrapper.vue?vue&type=script&lang=js&"
export * from "./FeatherIconWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports